// extracted by mini-css-extract-plugin
export default {"subList":"R3VlQYSPnNLFe8CG9rFW"};